import React, { useEffect, useState } from "react";
import { getFolderFileById } from "../../utils/treeData/folderEditorUtils";
import { useNavigate, useParams } from "react-router-dom";
import { useTreeContext } from "../../context/TreeDataContext";
import { useEntityContext } from "../../context/EntityContext";
import Loader from "../../Layouts/Loader/Loader";
import EntityMainSection from "./EntityEditor/EntityMainSection";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";

const EntityCenterViewer = () => {
  const [isLoading, setIsLoading] = useState(true);

  const { entityExplorerData } = useTreeContext();
  const { setSelectedEntity, selectedEntity } = useEntityContext();

  const { entityId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!entityExplorerData) return;
    const file = getFolderFileById(entityExplorerData, entityId);
    if (file) {
      setSelectedEntity({
        id: file.id,
        name: file.name,
        parentData: file.parentData
      });
      setIsLoading(false);
    } else {
      navigate("../");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityId, entityExplorerData]);

  const renderEntity = () => {
    switch (selectedEntity?.parentData) {
      case "entity":
      case "entities":
        return <EntityMainSection file={selectedEntity} />;
      default:
        return (
          <div className="d_flex justify_center align_center h_100">
            <ErrorMessage>Unsupported Type: {selectedEntity.parentData}</ErrorMessage>
          </div>
        );
    }
  };

  return <>{isLoading ? <Loader /> : <div className="content_main_section position_relative">{renderEntity()}</div>}</>;
};

export default EntityCenterViewer;
